import React, { useMemo } from 'react';
import { useCountry, Country } from '@increasecard/increase-core';
import { Switch, Route, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LeftColumn from '../../common/components/LeftColumn';
import { Constants } from '@card/commonlib';
import { DailyClearingsScreen } from './DailyClearingsScreen';
import { ClearingUploadScreen } from './ClearingUploadScreen';
import { TFunction } from 'i18next';
import { MonthlyClearingsScreen } from './MonthlyClearingsScreen';
import { TaxesScreen } from '../taxes/TaxesScreen';

const getLinks = (t: TFunction, pathname: string, country: string) => {
  const links = [
    {
      id: 'daily',
      href: '/clearings',
      label: t('sidebar.daily'),
      active: pathname === '/clearings',
      enabled: true
    },
    {
      id: 'monthly',
      href: '/monthlyClearings',
      label: t('sidebar.monthly'),
      active: pathname === '/monthlyClearings',
      notAvailableIn: [
        Constants.Countries.ECUADOR,
        Constants.Countries.DOMINICANA,
        Constants.Countries.URUGUAY
      ],
      enabled: true
    },
    {
      id: 'clearingUpload',
      href: '/clearings/upload',
      label: t(`sidebar.upload`),
      active: pathname === '/clearings/upload',
      notAvailableIn: [
        Constants.Countries.ARGENTINA,
        Constants.Countries.URUGUAY,
        Constants.Countries.DOMINICANA
      ],
      enabled: true
    },
    {
      id: 'taxes',
      href: '/taxes',
      label: t('sidebar.taxes'),
      active: pathname.includes('/tax'),
      enabled: true
    }
  ];
  return links.filter((link) => {
    if (!link.enabled || (link.notAvailableIn && link.notAvailableIn.includes(country))) {
      // link not enabled || not available in user's country
      return false;
    }
    return true;
  });
};

export function ClearingsScreen() {
  const { t } = useTranslation('clearings', { useSuspense: true });
  const history = useHistory();
  const country = useCountry() as Country;
  const availableLinks = useMemo(() => getLinks(t, history.location.pathname, country), [
    t,
    history.location.pathname,
    country
  ]);
  console.log(country, availableLinks);

  return (
    <React.Fragment>
      <LeftColumn links={availableLinks} />
      <Switch>
        <Route component={DailyClearingsScreen} exact path="/clearings" />
        <Route component={MonthlyClearingsScreen} exact path="/monthlyClearings" />
        <Route component={ClearingUploadScreen} exact path="/clearings/upload" />
        <Route component={TaxesScreen} exact path={['/taxes', '/taxations']} />
      </Switch>
    </React.Fragment>
  );
}
